import React, { useState, useEffect } from 'react';
import { formatPrice } from '../../utils/Formatting';
import { getPrizeAmount } from '../../constants/gameConfig';
import { useSettingsRedux } from '../../hooks/useSettingsRedux';
import { useWalletAnimation } from '../../hooks/statusbar/useWalletAnimation';
import { useProductConfirmation } from '../../hooks/statusbar/useProductConfirmation';
import CircularTimer from '../CircularTimer';
import walletIcon from '../../assets/wallet.png';
import './StatusBar.css';
import { StatusBarProps } from './StatusBar';

type ProductConfirmationBarProps = Pick<
  StatusBarProps,
  'walletAmount' | 'timeRemaining' | 'walletPulse' | 'walletRef' | 'showPrizeAnimation'
>;

const ProductConfirmationBar = ({
  walletAmount,
  timeRemaining,
  walletPulse,
  walletRef,
  showPrizeAnimation,
}: ProductConfirmationBarProps) => {
  const { settings } = useSettingsRedux();

  // Get dynamic prize amount from settings
  const prizeAmount = getPrizeAmount(settings);

  const animatedWalletAmount = useWalletAnimation(walletAmount, true);
  const { handleConfirmProductClick, confirmButtonClicked, cartLoading, currentSelectedProduct } =
    useProductConfirmation();
  const [showDelayedPrizeAnimation, setShowDelayedPrizeAnimation] = useState(false);

  useEffect(() => {
    if (showPrizeAnimation) {
      const delayTimeout = setTimeout(() => {
        setShowDelayedPrizeAnimation(true);
      }, 500);

      return () => clearTimeout(delayTimeout);
    } else {
      setShowDelayedPrizeAnimation(false);
    }
  }, [showPrizeAnimation]);

  return (
    <>
      <div className={`playmerce-game-statusbar-wallet ${walletPulse ? 'pulse' : ''}`} ref={walletRef}>
        <img src={walletIcon} alt="Wallet" className="wallet-icon" />
        <p className="wallet-amount">{formatPrice(animatedWalletAmount.toString(), 'EUR')}</p>
        {showDelayedPrizeAnimation && <div className="prize-animation">+{prizeAmount} €</div>}
      </div>
      <button
        className="choose-product-button"
        onClick={handleConfirmProductClick}
        disabled={!currentSelectedProduct || cartLoading || confirmButtonClicked}
      >
        {settings?.translations?.confirm?.confirm ?? 'Confirm Offer'}
      </button>
      <div className="playmerce-game-statusbar-timer">
        <CircularTimer timeRemaining={timeRemaining} size={50} strokeWidth={6} />
      </div>
    </>
  );
};

export default ProductConfirmationBar;
